import React, { useContext, useEffect, useState } from 'react';
import { Menu } from 'antd';
import { useLocation, NavLink } from 'react-router-dom';
import { DatabaseFilled, FileTextFilled, HomeFilled, QuestionCircleFilled, SettingFilled } from '@ant-design/icons';
import { UserContext } from '../contexts';
import { hasAdminPageRole, hasGridsPageRole, hasReportsPageRole } from '../../utils';

export function Navigation() {
  const { pathname } = useLocation();
  const [path, setPath] = useState('');
  const { user } = useContext(UserContext);

  useEffect(() => {
    const fixedPath = '/' + pathname.split('/')[1];
    setPath(fixedPath);
  }, [pathname]);

  return (
    <>
      <Menu theme="dark" mode="horizontal" selectedKeys={[path]} style={{ backgroundColor: '#294D78', textAlign: 'right' }}>
        <Menu.Item icon={<HomeFilled />} key="/">
          <NavLink to="/">Ana sayfa</NavLink>
        </Menu.Item>
        {hasGridsPageRole(user) && (
          <Menu.Item icon={<DatabaseFilled />} key="/grids">
            <NavLink to="/grids">Veri setleri</NavLink>
          </Menu.Item>
        )}
        {/* {hasTasksPageRole(user) && (
          <Menu.Item icon={<CalendarFilled />} key="/tasks">
            <NavLink to="/tasks">Görevler</NavLink>
          </Menu.Item>
        )} */}
        {hasReportsPageRole(user) && (
          <Menu.Item icon={<FileTextFilled />} key="/reports">
            <NavLink to="/reports">Raporlar</NavLink>
          </Menu.Item>
        )}
        {hasAdminPageRole(user) && (
          <Menu.Item icon={<SettingFilled />} key="/admin">
            <NavLink to="/admin">Yönetim</NavLink>
          </Menu.Item>
        )}
        {!user && (
          <Menu.Item icon={<QuestionCircleFilled />} key="/help">
            <NavLink to="/help">Yardım</NavLink>
          </Menu.Item>
        )}
      </Menu>
    </>
  );
}
